import { useAppSelector } from '@/hooks/store';
import { selectCurrentAccount } from '@/store/features/account/current-account.slice';
import {
  clearDemoMode,
  isDemoModeActive,
  isDemoModeAllowedOnCurrentPage,
  isDemoModeReadonlyPage,
} from '@/utils/demo-mode';
import { EyeIcon } from '@/utils/helpers';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Banner = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: var(--medium-padding) var(--default-padding);
  margin-bottom: var(--default-padding);
  border-radius: var(--semi-medium-border-radius);
  background-color: var(--green-opacity-lighter);

  svg {
    flex-shrink: 0;

    path {
      stroke: var(--green-main);
    }
  }
`;

const TextContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const DemoModeReadonlyBanner: React.FC = () => {
  const { t } = useTranslation();
  const currentAccount = useAppSelector(selectCurrentAccount);

  if (!currentAccount?.freeTrialEndsAt) {
    clearDemoMode();
    return null;
  }

  if (
    !isDemoModeAllowedOnCurrentPage() ||
    !isDemoModeReadonlyPage() ||
    !isDemoModeActive()
  ) {
    return null;
  }

  return (
    <Banner>
      <EyeIcon />
      <TextContainer>
        <p
          className="m-0"
          dangerouslySetInnerHTML={{ __html: t('demoMode.readonly.message') }}
        />
      </TextContainer>
    </Banner>
  );
};
